import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=7b3076fa&scoped=true"
import script from "./RoleDialog.vue?vue&type=script&lang=js"
export * from "./RoleDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleDialog.vue?vue&type=style&index=0&id=7b3076fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3076fa",
  null
  
)

export default component.exports